import React from 'react';
import { Box, Typography } from '@mui/material';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import PublisherLogo from '../../components/publisherLogo';

const card = {
    background: 'linear-gradient(180deg, rgba(255,255,255,0.05) 0%, rgba(255,255,255,0.015) 100%)',
    border: '1px solid rgba(187,188,188,0.14)',
    borderRadius: '22px',
    p: 2.5,
};

const recGrid = {
    display: 'grid',
    gridTemplateColumns: { xs: '1fr', sm: 'repeat(3, 1fr)' },
    gap: 1.5,
    mt: 2,
};

const recButton = {
    display: 'flex',
    alignItems: 'center',
    gap: 1.25,
    width: '100%',
    p: 1.25,
    borderRadius: '14px',
    background: 'rgba(255,255,255,0.025)',
    border: '1px solid rgba(187,188,188,0.14)',
    textAlign: 'left',
    cursor: 'pointer',
    transition: 'background 0.18s ease, border-color 0.25s ease, transform 0.18s ease, box-shadow 0.25s ease',
    '&:hover': {
        background: 'rgba(0,120,255,0.10)',
        borderColor: 'rgba(0,215,255,0.40)',
        transform: 'translateY(-1px)',
        boxShadow: '0 10px 24px -14px rgba(0,215,255,0.45)',
    },
};

const recCta = {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 0.375,
    fontSize: '0.7rem',
    fontWeight: 600,
    color: 'var(--ecal-lightblue)',
    flexShrink: 0,
};

function Recommended({ publishers = [], onSync }) {
    function renderPublisher(publisher) {
        return (
            <Box
                key={publisher.id || publisher.pubId}
                component="button"
                onClick={() => onSync && onSync(publisher)}
                aria-label={`Sync ${publisher.name} to your calendar`}
                sx={recButton}
            >
                <PublisherLogo
                    logo={publisher.logo}
                    name={publisher.name}
                    logoColors={publisher.logoColors}
                    size={40}
                />
                <Box sx={{ minWidth: 0, flex: 1 }}>
                    <Typography sx={{ fontSize: '0.875rem', fontWeight: 500, color: 'var(--ecal-white)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                        {publisher.name}
                    </Typography>
                    <Typography sx={{ fontSize: '0.6875rem', color: 'var(--ecal-lightgrey)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                        {publisher.industries?.[0]}
                    </Typography>
                </Box>
                <Box sx={recCta}>
                    <CalendarMonthIcon sx={{ fontSize: 14 }} />
                    Sync
                </Box>
            </Box>
        );
    }

    return (
        <Box sx={card}>
            <Typography sx={{ fontSize: '0.72rem', textTransform: 'uppercase', letterSpacing: '0.18em', color: 'var(--ecal-lightblue)' }}>
                Recommended for you
            </Typography>
            <Typography sx={{ fontSize: '0.72rem', color: 'var(--ecal-lightgrey)', mt: 0.5 }}>
                Tap a publisher brand to sync their events to your calendar.
            </Typography>

            <Box sx={recGrid}>
                {publishers.map(renderPublisher)}
            </Box>
        </Box>
    );
}

export default Recommended;
